import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-modal-edit-warehouse-purchase-order-detail',
  templateUrl: './modal-edit-warehouse-purchase-order-detail.component.html',
  styleUrls: ['./modal-edit-warehouse-purchase-order-detail.component.scss']
})
export class ModalEditWarehousePurchaseOrderDetailComponent implements OnInit {
  

  constructor(
    private purchaseOrderService: PurchaseOrderService,
    private warehouseService: WarehouseService,
    private toast: ToastrService) { 
    
  }

  ngOnInit(): void {
  }

  getWarehouses() {
    return this.warehouseService.getWarehouses();
  }

  editDetailWarehouse(detailId: number, warehouseId: number) {
    return this.purchaseOrderService.putEditDetailWarehouse(detailId, warehouseId);
  }
}
